<template>
  <div>
    <!-- dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="importDialog"
      :title="dialogTitle"
      width="75%"
      @close="clearImportData"
      @opened="opened"
    >
      <el-row class="import-table">
        <ImportData
          ref="import"
          importName="file"
          :excelName="excelName"
          :tableData="importTable"
          :uploadUrl="uploadUrl"
          :uploadBtnDisabled="importSelection.length === 0"
          @submit="sumbitTableData"
          @beginUpload="beginUpload"
          @returnData="returnData"
        >
          <el-popover
            v-if="permissionData.length > 1"
            placement="bottom"
            trigger="click"
          >
            <span v-for="(item, index) in permissionOriginData" :key="index">
              <el-link
                type="primary"
                v-if="permissionData.includes(item.href)"
                >{{ item.name }}</el-link
              >
            </span>
            <el-button slot="reference">下载模板</el-button>
          </el-popover>
          <el-button v-else size="mini" @click="downloadFile"
            >下载模板</el-button
          >
        </ImportData>
      </el-row>
      <wxe-table
        ref="wxeTable"
        :title="title"
        :importRowErrMsg="'errorMsg'"
        :tableData="importTable"
        :tableHead="tableColumns"
        :loading="loading"
        @wxe-table-select="importTableChange"
      />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button
          type="primary"
          size="mini"
          @click="sumbitTableData"
          :loading="submitLoading"
          :disabled="importSelection.length === 0"
          >确 定</el-button
        > -->
        <el-button
          type="primary"
          size="mini"
          @click="importDialog=false"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量操作后的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="resultDialogVisible"
    >
      <ResultDialog
        :dialogResult="dialogResult"
        :tableDataField="'failResultList'"
        tableLable="产品名称"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="resultDialogVisible = false"
          size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImportData from '@/components/ImportData';
import WxeTable from '@/components/ImportData/WxeTable';
import ResultDialog from '@/components/ResultDialog';
import { pageNameArr } from '@/utils/pageInfo';
import download from '@/utils/download';
import { groupBy, toPairs } from 'lodash';
import sampleImportMixin from '@/mixins/samplerImportMixin';

export default {
  components: { ImportData, WxeTable, ResultDialog },
  mixins: [sampleImportMixin],
  data() {
    return {
      uploadUrl:
        process.env.VUE_APP_CML_BASE_URL + 'fabricSample/batchImportPreview',
      tableColumns: [
        { prop: 'errorMsg', label: '提示' },
        { prop: 'productName', label: '产品名称' },
        { prop: 'productionCountryName', label: '生产产地' },
        { prop: 'fabricTypeName', label: '膜布类型' },
        { prop: 'fabricCategoryName', label: '膜布分类' },
        { prop: 'weight', label: '膜布重量（g）' },
        { prop: 'materialQuality', label: '膜布材质' },
        { prop: 'feature', label: '膜布特点' },
        { prop: 'dailyCapacity', label: '日产能（片）' },
        { prop: 'suggestVolume', label: '建议吸液量（ml）' },
        { prop: 'visualizationExperiment', label: '可视化实验' },
        { prop: 'printablePatternName', label: '是否可印图案' },
        { prop: 'compressibleObjectName', label: '是否可压实物' },
        { prop: 'havePatentName', label: '是否有专利' },
        { prop: 'price', label: '预估含税单价(元/片)' },
        { prop: 'productionCycle', label: '生产周期(天)' },
        { prop: 'minNum', label: '正式订单的最低起订量（张）' },
        { prop: 'haveMassProductionName', label: '是否做过大货生产' },
        { prop: 'developmentProgress', label: '开发进度' },
        { prop: 'brandsUsed', label: '已使用品牌' },
        { prop: 'deliveryTime', label: '样品的发货时间（天）' },
        { prop: 'shuiyangEnableName', label: '是否被水羊启用过' },
      ],
      excelName: '膜布样品导入模板.xlsx',
      dialogResult: {},
      resultDialogVisible: false,
    };
  },
  props: {
    importParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    importTable(val) {
      if (val.length === 0) this.$refs.import.fileList = [];
    },
  },
  mounted() {
    const { category, customerId } = this.$store.getters.userSupplier;
    this.category = category;
    this.customerId = customerId;
    // 判断是否具有多个权限, 目前外部供应商只有一种权限
    this.category = [category];
    this.permissionOriginData = pageNameArr;
    this.permissionData = this.category.reduce((prev, cur) => {
      if (this.permissionOriginData.findIndex(item => item.type === cur) > -1) {
        prev.push(cur);
      }
      return prev;
    }, []);
  },
  methods: {
    batchImport() {
      const parmas = this.combinationData();
      this.$http.sampleManage
        .batchImportFabricSample(parmas)
        .then(result => {
          if (result.data.failNum === 0) {
            this.$message.success(result.msg);
          } else {
            this.dialogResult = result.data;
            this.resultDialogVisible = true;
          }
          this.refreshData();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.submitLoading = false;
          this.$refs.import.loading = false;
        });
    },
    // 下载模板文件
    downloadFile() {
      download(
        process.env.VUE_APP_CML_BASE_URL + 'fabricSample/downloadFile',
        this.excelName,
      );
    },
    combinationData() {
      this.submitLoading = true;
      // 供应商样品分组
      const allGroupedItems = toPairs(
        groupBy(this.importSelection, 'supplierCode'),
      ).map(item => {
        return {
          supplierCode: item[0],
          arr: toPairs(groupBy(item[1], 'productName')),
        };
      });
      // 获取第一个供应商样品分类
      const groupedItems = allGroupedItems[0].arr.map(o => o[1]);
      // 组合样品数据
      const combinationData = groupedItems.map(items => {
        return {
          ...items[0],
        };
      });
      return combinationData;
    },
  },
};
</script>

<style lang="less" scoped>
.import-table {
  display: flex;
  align-items: center;
  margin-top: -20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.el-link {
  display: block;
  margin: 15px;
}
</style>
